<template>
  <div class="table-wrapper">
    <el-table v-min-height ref="table" :data="tableData" :height="500" header-cell-class-name="theader-th"
      cell-class-name="tbody-td">
      <el-table-column fixed label="ID号" prop="id" align="center" width="140" />
      <el-table-column prop="merchantName" align="center" label="店铺名称" min-width="180" />
      <el-table-column prop="appletsName" align="center" label="小程序名称" min-width="180" />
      <el-table-column prop="decorationPageName" label="装修页面名称" align="center" min-width="250" />
      <el-table-column prop="time" label="新建时间" align="center" min-width="180" />
      <el-table-column prop="editTime" label="最后一次编辑时间" align="center" min-width="180" />
      <el-table-column label="发布状态" align="center" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.status === '1' ? '未发布' : '已发布' }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="220" class-name="visible">
        <template slot-scope="scope">
          <el-button v-permission:editor="$route.meta.permission" size="36" round class="iconfont icon-bianji"
            @click="jumpDecorationDetails(scope.row)" />
          <el-button v-if="scope.row.status !== '2'" v-permission:del="$route.meta.permission" size="36" round
            class="iconfont icon-shanchu" @click="handleDelete(scope.$index, scope.row)" />
          <el-button v-if="scope.row.status !== '1'" v-permission:copy="$route.meta.permission"
            @click="copyDecoration(scope.row)" size="36" class="iconfont icon-fuzhi d5" round />
          <el-button v-if="scope.row.status !== '2'" v-html="'发布'" v-permission:release="$route.meta.permission" size="90"
            class="sub-color" @click="release(scope.row)" />
        </template>
      </el-table-column>
    </el-table>
    <div class="mask" v-if="dialogFormVisible">
      <el-dialog :visible.sync="dialogFormVisible" :modal-append-to-body="false" :close-on-click-modal="false"
        :close-on-press-escape="false" :show-close="false" :modal="false" custom-class="dialog" width="37.5rem"
        :center="true">
        <el-form label-width="auto">
          <el-form-item label="小程序名称：">
            <el-select v-model="appletsName" placeholder="请选择" clearable>
              <el-option :label="item.label" :value="item.value" v-for="item in filterDownData('appletsList')"
                :key="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="装修页面名称：">
            <el-input v-model="renovationName" clearable placeholder="请输入" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="sub-color" size="98" @click="selectApplets">
            确 定
          </el-button>
        </div>
      </el-dialog>
    </div>
    <Pagination v-if="pagination.recordTotal > 1" :currentPage="pagination.currentPage" :totalPage="pagination.pageTotal"
      :totalRecord="pagination.recordTotal" @handleNextPage="nextPage" @handlePrevPage="prevPage"
      @handleJumpPage="jumpPage" @handleChangePageSize="changePageSize" />
    <el-button size="220" round class="iconfont icon-xinzeng" @click="jumpDecorationDetails"
      v-permission:add="$route.meta.permission">
      新增装修页面
    </el-button>
  </div>
</template>

<script>
import tableOpearting from 'mixins/tableOpearting/'
import filterDownData from 'mixins/filterDownData'
export default {
  name: 'TableComponent',
  mixins: [tableOpearting, filterDownData],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => {
        return {}
      }
    },
    routeName: {
      type: String
    }
  },
  data() {
    return {
      dialogFormVisible: false,
      appletsName: '',
      renovationName: '',
      renovationId: ''
    }
  },
  methods: {
    /**
     * 跳转页面(编辑、新建)
     * @param rows
     */
    jumpDecorationDetails(rows) {
      const routeName = this.routeName
      const router = obj => {
        this.$router.push(obj)
      }
      let obj
      switch (routeName) {
        case 'appletsList':
          obj = {
            name: 'decorationApplets',
            query: {}
          }
          if (rows.id) {
            obj.query.id = rows.id
            obj.query.title = rows.appletsName
            obj.query.appletsId = rows.appletsId
            obj.query.renovationName = rows.decorationPageName
            obj.query.status = rows.status
            obj.query.decorationMethod = rows.decorationMethod
          } else {
            obj.query.title = '新增小程序装修'
          }
          router(obj)
          break
        case 'electronicScreenList':
          obj = {
            name: 'decorationElectronic',
            query: {}
          }
          if (rows.id) {
            obj.query.id = rows.id
            obj.query.title = rows.appletsName
            obj.query.ledId = rows.ledId
            obj.query.status = rows.status
          } else {
            obj.query.title = '新增电子屏装修'
          }
          router(obj)
          break
      }
    },
    /**
     * 调用父组件请求数据函数
     * @param vm
     * @param newValue
     * @param type
     * @param size
     * @private
     */
    _parentComponentRequest(vm, newValue, type, size) {
      const condition = vm.$refs.search._returnSearchCondition()
      vm._getDecorationList({
        curpage: newValue || 1,
        pageSize: size || 10,
        ...condition,
        renovation_type: this.$parent.decorationType
      })
    },
    /**
     * 删除
     * @param rows
     */
    delRows(rows) {
      return this.api
        .delDecorationItem({
          renovation_id: rows.id,
          renovation_type: this.$parent.decorationType
        })
        .then(() => {
          this.$notify({
            type: 'success',
            message: '删除成功~！🤔'
          })
        })
    },

    /**
     * 发布小程序装修页面
     * @param row
     */
    release(row) {
      this.$confirm('确定将小程序同步发布至线上', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        cancelButtonClass: 'el-button--98',
        confirmButtonClass: 'el-button--98 sub-color',
        type: 'warning',
        center: true
      }).then(res => {
        this.api
          .releaseApplets({
            renovation_type:
              this.routeName === 'appletsList' ? 'applet' : 'led',
            renovation_id: row.id,
            applet_id: row.appletsId,
            renovation_status: 2
          })
          .then(() => {
            const $parent = this.$parent
            this._parentComponentRequest(
              $parent,
              $parent.pagination.currentPage
            )
            this.$notify({
              type: 'success',
              message: '发布成功~！🙂'
            })
          })
      })
    },

    /**
     * 选择小程序
     */
    selectApplets(row) {
      if (this.appletsName === '' || this.renovationName === '') {
        this.$notify({
          type: 'warning',
          message: '请先选择要装修的小程序名称以及装修页面名称~！😝'
        })
        return
      }
      this.appletId = this.appletsName
      this.dialogFormVisible = false
      this.api
        .copyDecoration({
          renovation_id: this.renovationId,
          applet_id: this.appletId,
          renovation_type: this.$parent.decorationType,
          renovation_name: this.renovationName
        })
        .then(() => {
          const $parent = this.$parent
          this._parentComponentRequest($parent, $parent.pagination.currentPage)
          this.$notify({
            type: 'success',
            message: '复制成功~！🙂'
          })
        })
    },

    /*
     * 复制装修模板
     */
    copyDecoration(row) {
      this.renovationId = row.id
      this.dialogFormVisible = true
      // this.api
      //   .copyDecoration({
      //     renovation_id: row.id
      //   })
      //   .then(() => {
      //     const $parent = this.$parent
      //     this._parentComponentRequest($parent, $parent.pagination.currentPage)
      //     this.$notify({
      //       type: 'success',
      //       message: '复制成功~！🙂'
      //     })
      //   })
    }
  }
}
</script>
